import "./CostOfLivingIndex.module.css";
import Header from "@/reusable_sections/Header";
import ResourcesHero from "./sections/ResourcesHero";
import FeaturesFooter from "./sections/FeaturesFooter";
import MonthlyMovementSubscription from "./sections/MonthlyMovementSubscription";
import Footer from "@/reusable_sections/Footer";
export default function CostOfLivingIndexPage() {
  return <div>
      <Header />
      <ResourcesHero />
      <FeaturesFooter />
      <MonthlyMovementSubscription />
      <Footer />
    </div>;
}